import {
  Button,
  Col,
  Layout,
  Row,
  Spin,
  Table,
  Tag,
  Tooltip,
  Icon,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import { Constant } from "../../config";
import { GatewayColor, GatewayName } from "../../config/gateway";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import MyModal from "../Modal";
import { SENDERS_DEFAULT_HIGHEST_FLAG_UPDATING_KEY } from "../Senders/default";
import { SENDERS_DEFAULT_GATEWAY_FLAG_UPDATING_KEY } from "../Senders/default-gateway";
import SenderPoolForm from "./form";
import SearchForm from "./search-form";
import { checkRolePermission } from "../../services/permission";
import { permissionName, permissionType } from "../../config/permission";

const { Content } = Layout;

class SendersPool extends Component {
  state = {
    loading: false,

    countryList: [],
    countryListForrm: [],
    currentCountryAbbr: "",
    currentGatewayID: 0,
    currentPage: 1,
    currentSearch: "",
    dataSource: [],
    gatewayList: [],
    gatewayListForm: [],
    totalRows: 0,

    current_data: {
      id: 0,
      country_abbr: "",
      gateway_id: 0,
      sender: "",
      is_default: undefined,
      registered_date: null,
      expired_date: null,
    },
    flagCreateOrUpdateForm: true, // true: created, false: updated
    visibleFormModal: false,
    canAddSenderPool: false,
    canEditSenderPool: false,
    canDeleteSenderPool: false,
  };

  columns = [
    {
      align: "center",
      dataIndex: "created_date",
      render: (created_date) => {
        if (!created_date) return "-";

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {created_date}
          </Moment>
        );
      },
      title: "วัน / เวลา สร้าง",
      width: "150px",
    },
    {
      align: "center",
      dataIndex: "gateway_id",
      render: (_, record) => (
        <Tag color={GatewayColor(record.gateway_detail.key_name)}>
          {GatewayName(record.gateway_detail.key_name)}
        </Tag>
      ),
      title: "Gateway",
      width: "200px",
    },
    {
      align: "center",
      dataIndex: "country_abbr",
      render: (country_abbr) => {
        return (
          <Tag color="brown" style={{ fontWeight: "bold" }}>
            {country_abbr || "-"}
          </Tag>
        );
      },
      title: "ประเทศ",
      width: "100px",
    },
    {
      align: "center",
      dataIndex: "sender",
      title: "Sender",
      width: "200px",
    },
    {
        title: 'Registered Date',
        dataIndex: 'registered_date',
        align: 'center',
        width: '150px',
        render: (registered_date) => {
            if (!registered_date) return "-";
            return (
                <Moment unix tz="Etc/UTC" format="MMM DD YYYY">
                    {registered_date}
                </Moment>
            );
        },
    },
    {
        title: 'Expired Date',
        dataIndex: 'expired_date',
        align: 'center',
        width: '150px',
        render: (expired_date) => {
            if (!expired_date) return "-";
            return (
                <Moment unix tz="Etc/UTC" format="MMM DD YYYY">
                    {expired_date}
                </Moment>
            );
        },
    },
    {
      align: "center",
      dataIndex: "updated_date",
      render: (updated_date) => {
        if (!updated_date) return "-";

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {updated_date}
          </Moment>
        );
      },
      title: "วัน / เวลา แก้ไข ล่าสุด",
      width: "150px",
    },
     // {
    //   align: 'center',
    //   dataIndex: 'status',
    //   render: (status, record) => {
    //     if (typeof status === 'undefined') return '-';

    //     return (
    //       <Switch
    //         checkedChildren={<Icon type="check" />}
    //         unCheckedChildren={<Icon type="close" />}
    //         checked={status === 'enabled'}
    //         onChange={(e) => this.toggleStatus(e, record.id || 0, record.sender || '-')}
    //       />
    //     );
    //   },
    //   title: 'สถานะ',
    //   width: '100px',
    // },
    {
      title: "ดำเนินการ",
      align: "center",
      dataIndex: "id",
      width: "120px",
      render: (id, record) => {
        if (typeof id === "undefined" || typeof record === undefined)
          return "-";

        const d = record || undefined;
        const isSendersDefault = d ? d.is_senders_default : undefined;
        const sender = d ? d.sender || "" : "";

        if (!this.state.canEditSenderPool && !this.state.canDeleteSenderPool) {
          return <Icon type="lock" />;
        }

        return (
          <div>
            {this.state.canEditSenderPool && (
              <Tooltip placement="top" title="แก้ไข">
                <Button
                  icon="edit"
                  onClick={() => this.edit(d)}
                  style={{ marginRight: "5px" }}
                />
              </Tooltip>
            )}

            {typeof isSendersDefault === "boolean" &&
              this.state.canDeleteSenderPool && (
                <Tooltip placement="top" title="ลบ">
                  <Button
                    type="danger"
                    icon="delete"
                    onClick={() => this.delete(id, sender)}
                    disabled={isSendersDefault}
                  />
                </Tooltip>
              )}
          </div>
        );
      },
    },
  ];
  limit = 20;

  componentWillMount() {
    this.props.fetchMenuAction("senders", "senders-pool");
    this.setState({ loading: true });

    const canAddSenderPool = checkRolePermission(
      permissionName.SENDER_POOL,
      permissionType.CREATE
    );
    const canEditSenderPool = checkRolePermission(
      permissionName.SENDER_POOL,
      permissionType.UPDATE
    );
    const canDeleteSenderPool = checkRolePermission(
      permissionName.SENDER_POOL,
      permissionType.DELETE
    );

    this.setState({
      canAddSenderPool,
      canEditSenderPool,
      canDeleteSenderPool,
    });
  }

  async componentDidMount() {
    await this.getDataList();
    this.setState({
      countryList: await this.getCountryList(),
      gatewayList: await this.getGatewayList(),
      loading: false,
    });
  }

  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.getDataList(
      page,
      this.state.currentSearch,
      this.state.currentCountryAbbr,
      this.state.currentGatewayID
    );

    this.setState({ loading: false });
  };

  create = () => {
    this.setState({
      current_data: {
        id: 0,
        country_abbr: undefined,
        gateway_id: undefined,
        sender: undefined,
        is_default: undefined,
        registered_date: null,
        expired_date: null,
      },
      flagCreateOrUpdateForm: true,
      visibleFormModal: true,
    });
  };

  delete = (id = 0, sender = "") => {
    if (!id || !sender) return 0;

    MyModal.confirm(
      "ต้องการลบรายการนี้ ใช่หรือไม่ ?",
      `Sender: ${sender || "-"}`,
      async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({ loading: true });

        try {
          await axios({
            url: `${Constant.SENDERS_POOL_API}/${id}`,
            method: "DELETE",
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem(Constant.SessionKey),
            },
          });

          MyModal.success("ลบรายการสำเร็จ");

          await this.changePage(this.state.currentPage);
        } catch (e) {
          const errorMsg = `เกิดข้อผิดพลาด ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
          let eMsgDetail = "";

          if (e.response && e.response.data && e.response.data.error) {
            const tmp = e.response.data.error;
            eMsgDetail = `[${tmp.code || ""}] ${tmp.name || ""}`;
          }

          MyModal.error(errorMsg, eMsgDetail, () => window.location.reload());
        }
      },
      "ยืนยัน",
      "ยกเลิก"
    );
  };

  edit = (d) => {
    if (!d) return 0;
    if (!d.id || !d.country_abbr || !d.gateway_id || !d.sender) return 0;

    this.setState({
      current_data: {
        id: d.id,
        country_abbr: d.country_abbr,
        gateway_id: d.gateway_id,
        sender: d.sender,
        is_default: d.is_senders_default,
        registered_date: d.registered_date,
        expired_date: d.expired_date,
      },
      flagCreateOrUpdateForm: false,
      visibleFormModal: true,
    });
  };

  formHandleSubmit = () => {
    const { form } = this.formRef.props;

    form.validateFields(async (err, values) => {
      if (err) return;

      const payload = {
          ...values,
          registered_date: values.registered_date
              ? values.registered_date.startOf('day').format('YYYY-MM-DD HH:mm:ss')
              : null,
          expired_date: values.expired_date
              ? values.expired_date.startOf('day').format('YYYY-MM-DD HH:mm:ss')
              : null,
      };

      MyModal.confirm(
        "ยืนยันบันทึกข้อมูล ใช่หรือไม่ ?",
        "",
        async (isConfirm) => {
          if (!isConfirm) return;

          this.setState({ loading: true });

          const modeText = this.state.flagCreateOrUpdateForm
            ? "เพิ่ม"
            : "แก้ไข";
          const errorMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeText}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
          const token = localStorage.getItem(Constant.SessionKey);
          let url = Constant.SENDERS_POOL_API;
          if (!this.state.flagCreateOrUpdateForm) url += `/${values.id}`;

          const opt = {
            data: payload,
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            method: this.state.flagCreateOrUpdateForm ? "POST" : "PATCH",
            url,
          };

          try {
            await axios(opt);

            if (this.state.flagCreateOrUpdateForm) form.resetFields();

            MyModal.success(`${modeText}ข้อมูลสำเร็จ`, "", async () => {
              await this.changePage(this.state.currentPage);

              if (values.id === 1) {
                window.localStorage.setItem(
                  SENDERS_DEFAULT_HIGHEST_FLAG_UPDATING_KEY,
                  "1"
                );
              } else if (values.is_default) {
                window.localStorage.setItem(
                  SENDERS_DEFAULT_GATEWAY_FLAG_UPDATING_KEY,
                  "1"
                );
              }

              this.setState({
                current_data: {
                  id: 0,
                  country_abbr: "",
                  gateway_id: 0,
                  sender: "",
                  is_default: false,
                  registered_date: null,
                  expired_date: null,
                },
                flagCreateOrUpdateForm: true,
                loading: false,
                visibleFormModal: false,
              });
            });
          } catch (e) {
            let eMsgDetail = "";

            if (e.response && e.response.data && e.response.data.error) {
              const tmp = e.response.data.error;
              eMsgDetail = `[${tmp.code || ""}] ${tmp.name || ""}`;
            }

            MyModal.error(errorMsg, eMsgDetail, () => window.location.reload());
          }
        },
        "ยืนยัน",
        "ยกเลิก"
      );
    });
};

  formHandleCancel = () => {
    this.setState({
      current_data: {
        id: 0,
        country_abbr: undefined,
        gateway_id: undefined,
        sender: "",
        registered_date: null,
        expired_date: null,
      },
      visibleFormModal: false,
    });
  };

  getCountryList = async () => {
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    this.setState({ countryListForrm: resp.data.data });

    let rtn = [{ region_code: "", name: "ทั้งหมด" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  };

  getDataList = async (
    page = 1,
    search = "",
    country_abbr = "",
    gateway_id = 0
  ) => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.SENDERS_POOL_API}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: "GET",
      params: {
        page,
        limit: this.limit,
        search,
        country_abbr,
        gateway_id,
        status: "enabled",
        order: "desc",
      },
      url,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined.");
    } catch (e) {
      console.error(e);
      return;
    }

    this.setState({
      currentPage: resp.data.page || 1,
      dataSource: resp.data.data || [],
      loading: false,
      totalRows: resp.data.total_rows || 0,
    });
  };

  getGatewayList = async () => {
    const opt = {
      url: `${Constant.GATEWAY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    this.setState({ gatewayListForm: resp.data.data });

    let rtn = [{ id: 0, name: "ทั้งหมด" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  };

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      const currentCountryAbbr = values.country_abbr || "";
      const currentGatewayID = values.gateway_id || 0;
      const currentPage = 1;
      const currentSearch = values.searchTxt || "";

      this.setState({
        currentCountryAbbr,
        currentGatewayID,
        currentPage,
        currentSearch,
        loading: true,
      });

      await this.getDataList(
        currentPage,
        currentSearch,
        currentCountryAbbr,
        currentGatewayID
      );

      this.setState({ loading: false });
    });
  };

  resetSearch = async () => {
    this.setState({ loading: true });

    await this.getDataList(1);

    this.setState({
      currentCountryAbbr: undefined,
      currentGatewayID: undefined,
      currentPage: 1,
      currentSearch: undefined,
      loading: false,
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  toggleStatus = (f, id = 0, sender = "") => {
    if (id < 1) {
      window.location.reload();
      return;
    }

    let textConfirm = "ปิดการใช้งาน";
    let url = Constant.SENDERS_POOL_API_DISABLED;
    if (f) {
      textConfirm = "เปิดการใช้งาน";
      url = Constant.SENDERS_POOL_API_ENABLED;
    }

    MyModal.confirm(
      `ต้องการ ${textConfirm} รายการนี้ ใช่หรือไม่ ?`,
      `Sender: ${sender || "-"}`,
      async (isConfirm) => {
        if (!isConfirm) {
          return;
        }

        this.setState({ loading: true });

        try {
          await axios({
            url: url.replace("[id]", id),
            method: "PATCH",
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem(Constant.SessionKey),
            },
          });

          MyModal.success(`${textConfirm} สำเร็จ`);

          await this.changePage(this.state.currentPage);
        } catch (e) {
          console.log(e);
          MyModal.error(
            "เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง"
          );
          this.setState({ loading: false });
        }
      },
      "ยืนยัน",
      "ยกเลิก"
    );
  };

  render() {
    const propsTable = {
      bordered: true,
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: "small",
      },
      size: "small",
      scroll: {
        x: 1500,
      },
    };
    const propsTableForMobile = Object.assign({}, propsTable);

    propsTableForMobile.className = "my-table-mobile";
    propsTableForMobile.columns = this.columnsMobile;

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: "16px 0",
              minHeight: 300,
            }}
          >
            <h2>Sender Pool</h2>
            <p className="header-desc">รายการ Sender ทั้งหมดในระบบ</p>
            <Row className="utility-bar">
              <Col span={6}>
                {this.state.canAddSenderPool && (
                  <Button icon="plus-circle" onClick={() => this.create()}>
                    เพิ่ม
                  </Button>
                )}
              </Col>
              <Col span={18}>
                <SearchForm
                  countryList={this.state.countryList}
                  gatewayList={this.state.gatewayList}
                  fn={this.mySearch}
                  fnReset={this.resetSearch}
                />
              </Col>
            </Row>
            <Row className="utility-bar-mobile">
              <Button icon="plus-circle" onClick={() => this.create()}>
                เพิ่ม
              </Button>
            </Row>
            <Row className="utility-bar-mobile">
              <SearchForm
                countryList={this.state.countryList}
                gatewayList={this.state.gatewayList}
                fn={this.mySearch}
                fnReset={this.resetSearch}
              />
            </Row>
            <Table {...propsTable} />
            <Table {...propsTableForMobile} />
            <div>
              <p style={{ color: "#f00", textDecoration: "underline" }}>
                หมายเหตุ
              </p>
              <ul>
                <li>
                  กรณีปุ่ม <Button type="danger" icon="delete" /> ไม่สามารถกดได้
                  เนื่องจาก Senders นั้นๆ ถูกใช้งานเป็น Default ของระบบ หรือเป็น
                  Default ของ Gateway
                </li>
              </ul>
            </div>
          </Content>
        </Spin>
        <SenderPoolForm
          countryList={this.state.countryListForrm}
          gatewayList={this.state.gatewayListForm}
          loading={this.state.loading}
          data={this.state.current_data}
          flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
          onCancel={this.formHandleCancel}
          onCreate={this.formHandleSubmit}
          visible={this.state.visibleFormModal}
          wrappedComponentRef={this.saveFormRef}
        />
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};



export default connect(null, mapDispatchToProps)(SendersPool);



// WEBPACK FOOTER //
// ./src/containers/SendersPool/index.js